import {CorrespondantDto} from "@resources/resources";
import {TranslateService} from "@ngx-translate/core";
import {Component} from "@angular/core";
import {CerbaCookieService, CookieConstantes, CorrespondantStore} from "@digicerba/common";

@Component({
  selector: 'cm-header',
  templateUrl: './header.component.html',
  host: {'class': 'header'}
})
export class HeaderComponent {

  correspondants : Array<CorrespondantDto> = [];
  selectedValue : CorrespondantDto = null;

  constructor(private cookieService: CerbaCookieService,
              private correspondantStore: CorrespondantStore,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.correspondants = this.correspondantStore.getCorrespondants();
    this.selectedValue = this.correspondantStore.getCorrespondant();

    let tags: any[] = this.selectedValue.tags;

    if (tags.indexOf("en") != -1 && tags.indexOf("fr") == -1) {
      this.translate.use('en');
    }
    else {
      this.translate.use('fr');
    }
  }

  onCorrespondantChange(newValue : CorrespondantDto) {
    this.selectedValue = newValue;
    this.correspondantStore.setCorrespondant(newValue);
    this.cookieService.removeCoockie(CookieConstantes.COOKIE_CORRESPONDANT);
    this.cookieService.addCoockie(CookieConstantes.COOKIE_CORRESPONDANT, this.correspondantStore.getCorrespondant().code);

    if (this.selectedValue) {
      let tags: any[] = this.selectedValue.tags;

      if (tags.indexOf("en") != -1 && tags.indexOf("fr") == -1) {
        this.translate.use('en');
      }
      else {
        this.translate.use('fr');
      }
    } else {
      this.translate.use('fr');
    }

    window.location.reload(true);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/header/header.component.ts